export default __webpack_public_path__ + "static/media/462.91d25fe1.jpg";